import { render, staticRenderFns } from "./CardsComponent.vue?vue&type=template&id=166f4adc&scoped=true"
import script from "./CardsComponent.vue?vue&type=script&lang=js"
export * from "./CardsComponent.vue?vue&type=script&lang=js"
import style0 from "./CardsComponent.vue?vue&type=style&index=0&id=166f4adc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "166f4adc",
  null
  
)

export default component.exports